/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Chat_Model_Settings_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Higher reasoning lets the model think through more intermediate steps before answering, which helps with complex analysis. Lower reasoning is faster for quic..." |
*
* @param {Uno_Edu_Chat_Model_Settings_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_chat_model_settings_chip2_answer = /** @type {((inputs?: Uno_Edu_Chat_Model_Settings_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Chat_Model_Settings_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Höheres Reasoning lässt das Modell mehr Zwischenschritte durchdenken, bevor es antwortet, was bei komplexen Analysen hilft. Niedrigeres Reasoning ist schneller für einfache, unkomplizierte Aufgaben. Nicht jedes Modell unterstützt dies.")
	return /** @type {LocalizedString} */ ("Higher reasoning lets the model think through more intermediate steps before answering, which helps with complex analysis. Lower reasoning is faster for quick, straightforward tasks. Not every model supports it.")
});